import Breadcrumb from "../SharedComponents/components/Breadcrumb/Breadcrumb";
import SellerLayout from "./components/SellerLayout";
import RightArrowIconSVG from "../SharedComponents/assets/icons/svg/RightArrowIconSVG";
import CreatePartOffer from "./components/CreatePartOfferComponents/CreatePartOffer";

const CreateOfferPage = () => {
    const breadcrumbs = [
        { title: "Početak", href: "/home" },
        { title: "Svi zahtevi", href: "/request" },
        // Individual request missing
        { title: "Napravi ponudu" }
    ];

    return (
        <SellerLayout>
            <div style={styles.breadcrumbContainer}>
                <div style={styles.iconStyle}>
                    <RightArrowIconSVG />
                </div>
                <Breadcrumb
                    title={"Napravi ponudu"}
                    breadcrumbs={breadcrumbs}
                />
            </div>
            <CreatePartOffer />
        </SellerLayout>
    );
};

export default CreateOfferPage;

const styles = {
    breadcrumbContainer: {
        display: "flex"
    },
    iconStyle: {
        filter: 'brightness(0) saturate(100%)',
        scale: "80%",
        rotate: "180deg",
        paddingTop: 35
    }
};
